import React, { useEffect, useMemo, useRef, useState } from 'react'
import { DeviceEventEmitter, ScrollView, Text, useWindowDimensions, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../js/formatDate';
import { useDispatch, useSelector } from 'react-redux';
import { formatLocalTime } from '../../js/utility';
import CustomPressable from '../../components/customPressable/customPressable';
import RenderHTML from 'react-native-render-html';
import { toBool } from '../../utils/Helper';
import { formatTime } from '../../js/formatTime';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { ImageComp } from '../../components/Image/Image';
import { ADD, MINUS } from '../../assets';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
import DatePickerModal from '../../components/datePickerModal/datePickerModal';
import moment from 'moment';
import { CustomTextInput } from '../../components/customTextInput';

const ActivitiesCreateBooking = (props) => {
    const { selectedEvent, setSelectedEvent, participantCount, handleUpdatedSelectedEventObj, availability, handleNext, handleGoBack } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();
    const { width } = useWindowDimensions()
    const dispatch = useDispatch();

    const { extraConfigParam } = useSelector(state => state.deviceConfigSlice,);
    const dateFormat = extraConfigParam?.DATE_FORMAT;
    const TIME_FORMAT = extraConfigParam?.TIME_FORMAT_MERIDIEM || false;

    const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);
    const [isNonRecurringEvent, setIsNonRecurringEvent] = useState(Boolean (selectedEvent?.event?.kind=="event" && selectedEvent?.eventInfo.firstAvailableDate && selectedEvent?.eventInfo.firstAvailableDate.scheduledDate));

    const mainScrollRef = useRef(null);

    const [remainingStock, setRemainingStock] = useState(selectedEvent?.type?.remainingStock || 0);

    const visibleTimeSlots = useMemo(() => availability?.availableVisibleTimeSlots?.find((a) => a.date == (selectedEvent?.selectedDate || selectedEvent?.eventInfo?.firstAvailableDate?.scheduledDate))?.visibleTimeSlots

        // eslint-disable-next-line react-hooks/exhaustive-deps
    , [selectedEvent?.selectedDate, selectedEvent?.eventInfo?.firstAvailableDate?.scheduledDate]);


    const scrollToBottom = () => {
        setTimeout(() => {
            mainScrollRef.current?.scrollToEnd({ animated: true });
        }, 200);
    }

    const handleTimeSlotSelect = (value, currentSlots, currentDate) => {
        const slots = currentSlots !== undefined ? currentSlots : visibleTimeSlots;
        if (!slots) {
            return;
        }

        const date = currentDate !== undefined ? currentDate : selectedEvent?.selectedDate;
        const key = date + value[0].startTime + value[0].endTime;
        const slotEntry = slots[key]?.[0];

        if (!slotEntry) {
            return;
        }

        const priceTiers = slotEntry.priceTiers;
        const updateTiers = priceTiers?.map((tier) => {
            return {...tier, quantity: 0};
        });

        handleUpdatedSelectedEventObj({
            timeSlot: {
                startTime: value[0].startTime,
                endTime: value[0].endTime
            },
            priceTiers: updateTiers || [],
            type: slotEntry
        });

        setRemainingStock(slotEntry?.remainingStock || 0);
    }

    const handleResetPriceTiers = () => {
        handleUpdatedSelectedEventObj( {
            timeSlot: null,
            priceTiers: null,
            type: null
        });
    }

    const handleBackPress = () => {
        handleResetPriceTiers();
        handleGoBack();
    }

    const onPackageQuantityUpdate = (id, change) => {
        const packages = [...selectedEvent.priceTiers];
        const updatedPackage = packages.map((p)=>{
            if(p.id != id) return p;

            return {...p, quantity: p.quantity + change};
        })
        handleUpdatedSelectedEventObj({priceTiers: updatedPackage});

        const newRemainingStock = remainingStock - change;
        setRemainingStock(newRemainingStock < 0 ? 0 : newRemainingStock);
    };

    const customWidgetDescriptionStyle = useMemo(() => {
        const style = getStyles(['widgetmainContainerHeaderSubTitle', 'activitiesCreateBookingHeaderDescription']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNextPress = (event) => {

        if(!participantCount) {
            dispatch(setRenderFlashMessage(true, {type: "danger", message: t("way_activity.create_booking.add_person_message")}));
            return
        }

        handleNext(event)
    }

    const handleSelectSingleTimeSlot = (updatedDate, currentVisibleTimeSlots) => {
        const slots = currentVisibleTimeSlots !== undefined ? currentVisibleTimeSlots : visibleTimeSlots;

        if (slots) {
            const visibleTimeSlotsKeys = Object.keys(slots);
            const filteredVisibleTimeSlotsKeys = visibleTimeSlotsKeys.filter(
                (v) => v.includes(updatedDate || selectedEvent?.selectedDate)
            );

            if (filteredVisibleTimeSlotsKeys?.length === 1) {
                const resolvedDate = updatedDate || selectedEvent?.selectedDate;
                handleTimeSlotSelect(slots[filteredVisibleTimeSlotsKeys[0]], slots, resolvedDate);
            }
        } else {
            handleResetPriceTiers();
        }
    };

    const handleDateChange = (selectedDate) => {
        setIsDatePickerVisible(false);
        const updatedDate = moment(selectedDate).format('YYYY-MM-DD');

        setSelectedEvent((prev) => {
            return {
                ...prev,
                selectedDate: updatedDate,
            };
        });

        handleResetPriceTiers();

        const newVisibleTimeSlots = availability?.availableVisibleTimeSlots?.find(
            (a) => a.date === updatedDate
        )?.visibleTimeSlots;

        handleSelectSingleTimeSlot(updatedDate, newVisibleTimeSlots);

        setRemainingStock(selectedEvent?.type?.remainingStock || 0);

        if (!selectedEvent?.selectedDate) {
            scrollToBottom();
        }
    };

    useEffect(() => {
        setRemainingStock(selectedEvent?.type?.remainingStock || 0);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedEvent?.type?.remainingStock])

    useEffect(() => {
        handleSelectSingleTimeSlot();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visibleTimeSlots]);

    useEffect(() => {
        if(isNonRecurringEvent){
            handleDateChange(selectedEvent?.eventInfo?.firstAvailableDate?.scheduledDate)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isNonRecurringEvent])
    

    
    const renderHeader = () => {
        const imageUri =
                selectedEvent?.event?.coverMedia?.uri?.original ||
                selectedEvent?.event?.coverMedia?.uri?.['1080w'] ||
                selectedEvent?.event?.coverMedia?.uri?.['750w'] ||
                selectedEvent?.event?.coverMedia?.uri?.['640w'] ||
                (Array.isArray(selectedEvent?.event?.pictures) && selectedEvent?.event?.pictures[0]?.uri?.original) ||
                null;
        return (
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'activitiesCreateBookingHeaderContainer'])} id='activitiesCreateBookingHeaderContainer'>
                <ImageComp source={imageUri} style={getStyles(['widgetmainContainerHeaderImg', 'activitiesCreateBookingMainContainerHeaderImg'])} id="widgetmainContainerHeaderImg activitiesCreateBookingMainContainerHeaderImg"/>

                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'activitiesCreateBookingHeaderTitleContainer'])} id='activitiesCreateBookingHeaderTitleContainer'>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'activitiesBookingEventListHeaderTitle'])} id='activitiesBookingEventListHeaderTitle'>
                        {selectedEvent?.event?.title}
                    </Text>

                    <RenderHTML
                        contentWidth={width}
                        baseStyle={customWidgetDescriptionStyle}
                        source={{ html: selectedEvent?.event?.description}}
                        systemFonts={[customWidgetDescriptionStyle.fontFamily]}
                        id="widgetmainContainerHeaderSubTitle activitiesCreateBookingHeaderDescription"
                    />
                </View>
            </View>
        )
    }

    return (
        <View style={getStyles(['widgetRootContainer', 'activitiesCreateBookingRootContainer'])} id='activitiesCreateBookingRootContainer'>
            <HeaderWithBack handleCustomBackPress={handleBackPress} />

            <ScrollView
                ref={mainScrollRef}
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'activitiesCreateBookingMainContainer'])} 
                showsVerticalScrollIndicator={false}
                id='activitiesCreateBookingMainContainer'
            >
                {renderHeader()}


                <View style={getStyles(['widgetmainContainerChildContainer', 'activitiesCreateBookingMainContainerChildContainer'])} id='activitiesCreateBookingMainContainerChildContainer'>
                    <Text style={getStyles(['label', 'activitiesFirstAvailableDateLabel'])} id='label activitiesFirstAvailableDateLabel'> 
                        {t("way_activity.create_booking.select_date")}
                    </Text>

                    <CustomPressable onPress={() => setIsDatePickerVisible(true)} disabled={isNonRecurringEvent}>
                        <CustomTextInput
                            value={!isNonRecurringEvent ? 
                                selectedEvent?.selectedDate ? 
                                    formatDate(selectedEvent?.selectedDate, dateFormat) 
                                    : "" 
                                : formatDate(selectedEvent?.eventInfo?.firstAvailableDate?.scheduledDate)
                            }
                            placeholder={t('way_activity.event_list.date_placeholder')}
                            editable={false}
                            pointerEvents="none"
                        />
                    </CustomPressable>

                    {isNonRecurringEvent && <Text style={getStyles(['label', 'activitiesFirstAvailableDateText'])} id='label activitiesFirstAvailableDateText'> 
                        {t("way_activity.event_list.one_day_available")?.replace("#DATE", `${formatDate(selectedEvent?.eventInfo?.firstAvailableDate?.scheduledDate)}`)}
                        </Text>}

                    {selectedEvent?.selectedDate && <>
                        <Text style={getStyles(['activitiesCreateBookingTimeSlots' ])} id='activitiesCreateBookingTimeSlots'>
                            {t('way_activity.create_booking.timeslots')}
                        </Text>

                        <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={getStyles(['activitiesCreateBookingTimeSlotsContainer'])} id="activitiesCreateBookingTimeSlotsContainer" style={{ width: '100%', maxHeight: 63 }}>
                            {visibleTimeSlots && Object.entries(visibleTimeSlots).length > 0 ? 
                            
                                (
                                    Object.entries(visibleTimeSlots).map(([key, value]) => {
                                        if(!key.includes(selectedEvent?.selectedDate)){
                                            return
                                        }
                                        return (
                                            <CustomPressable
                                                key={key}
                                                style={getStyles(['activitiesCreateBookingTimeSlotsItemContainer', selectedEvent.timeSlot && ( key === (selectedEvent?.selectedDate + selectedEvent.timeSlot.startTime + selectedEvent.timeSlot.endTime )) ? "activitiesCreateBookingTimeSlotsItemSelectedContainer" : ""])}
                                                onPress={()=> handleTimeSlotSelect(value)}
                                                id="activitiesCreateBookingTimeSlotsItemContainer activitiesCreateBookingTimeSlotsItemSelectedContainer"
                                            >
                                                <Text style={getStyles(['activitiesCreateBookingTimeSlotsItemText', selectedEvent.timeSlot && ( key === (selectedEvent?.selectedDate + selectedEvent.timeSlot.startTime + selectedEvent.timeSlot.endTime )) ? "activitiesCreateBookingTimeSlotsItemSelectedText" : ""])} id='activitiesCreateBookingTimeSlotsItemText activitiesCreateBookingTimeSlotsItemSelectedText'>
                                                    {formatTime(value[0].startTime,toBool(TIME_FORMAT)) + "-" + formatTime(value[0].endTime,toBool(TIME_FORMAT))}
                                                </Text>
                                            </CustomPressable>
                                    )})
                                )
                            
                            :
                            <Text style={getStyles(['activitiesCreateBookingNoSessions'])} id='activitiesCreateBookingNoSessions'>{t('way_activity.create_booking.nosessions')}</Text>             
                            }
                        </ScrollView>

                        {selectedEvent?.priceTiers?.length && <>
                            <Text style={getStyles(['activitiesCreateBookingSelectHeading'])} id='activitiesCreateBookingSelectHeading'>{t("way_activity.create_booking.select_subevents")}</Text>

                            <Text style={getStyles(['activitiesCreateBookingSelectSubHeading'])} id='activitiesCreateBookingSelectSubHeading'>
                                {t("way_activity.create_booking.remaining_seats").replace("#REMAININGSTOCK", remainingStock)}
                            </Text>


                            {selectedEvent?.type?.remainingStock > 0 ? selectedEvent?.priceTiers?.map((p, index) => (
                                <View key={index} style={getStyles(['list_itemContainer', 'activitiesCreateBookingSelectedEventContainer'])} id='list_itemContainer activitiesCreateBookingSelectedEventContainer'>
                                    <View style={getStyles(['activitiesCreateBookingSelectedEventTextContainer'])} id='activitiesCreateBookingSelectedEventTextContainer'>
                                        <Text style={getStyles(['activitiesCreateBookingSelectedEventTextName'])} id='activitiesCreateBookingSelectedEventTextName'>{p.name} </Text>
                                        <Text style={getStyles(['activitiesCreateBookingSelectedEventTextPrice'])} id='activitiesCreateBookingSelectedEventTextPrice'>{`${selectedEvent?.eventInfo?.currency} ${p.price}`} </Text>
                                    </View>

                                    <View style={getStyles(['activitiesCreateBookingSelectedEventButtonContainer'])} id='activitiesCreateBookingSelectedEventButtonContainer'>
                                        <CustomPressable 
                                            disabled={!participantCount}
                                            style={getStyles(['activitiesCreateBookingSelectedEventMinusButtonContainer'])}
                                            onPress={() => onPackageQuantityUpdate(p.id, -1)}
                                            id="activitiesCreateBookingSelectedEventMinusButtonContainer"
                                        >
                                            <ImageComp source={MINUS} style={getStyles(['activitiesCreateBookingSelectedEventMinusButton'])} id="activitiesCreateBookingSelectedEventMinusButton" />
                                        </CustomPressable>

                                        <Text style={getStyles(['activitiesCreateBookingSelectedEventQuantity'])} id='activitiesCreateBookingSelectedEventQuantity'>
                                            {p.quantity} 
                                        </Text>

                                        <CustomPressable 
                                            disabled={participantCount >= selectedEvent.type.remainingStock}
                                            style={getStyles(['activitiesCreateBookingSelectedEventAddButtonContainer'])}
                                            onPress={() => onPackageQuantityUpdate(p.id, 1)}
                                            id="activitiesCreateBookingSelectedEventAddButtonContainer"
                                        >   
                                            <ImageComp source={ADD} style={getStyles(['activitiesCreateBookingSelectedEventAddButton'])} id="activitiesCreateBookingSelectedEventAddButton" />
                                        </CustomPressable>
                                    </View>
                                </View>
                            )) : <Text style={getStyles(['activitiesCreateBookingNoSessions'])} id='activitiesCreateBookingNoSessions'>{t('way_activity.create_booking.no_price_tiers')}</Text>}
                        </>}

                        <View style={getStyles(['activitiesCreateBookingCancellationPolicyContainer'])} id='activitiesCreateBookingCancellationPolicyContainer'>
                            <Text style={getStyles(['activitiesCreateBookingCancellationPolicyTitle'])} id='activitiesCreateBookingCancellationPolicyTitle'>{t('way_activity.create_booking.cancel')}</Text>
                            <Text style={getStyles(['activitiesCreateBookingCancellationPolicySubDescription'])} id='activitiesCreateBookingCancellationPolicySubDescription'>{t("way_activity.create_booking.cancel_description")}</Text>
                        </View> 
                    </>}
                </View>
            
            </ScrollView>

            {isDatePickerVisible && !isNonRecurringEvent &&
                <DatePickerModal
                    selectedDate={selectedEvent?.selectedDate}
                    onDateChange={handleDateChange}
                    onClose={() => setIsDatePickerVisible(false)}
                    availableDates={availability?.availableVisibleTimeSlots?.length ? availability?.availableVisibleTimeSlots?.map((a) => a.date) : ['0000-00-00']}
                />
            }

            
            <View id='activitiesBookingNextButtonContainer' style={getStyles(['activitiesBookingNextButtonContainer'])}>
                <CustomPressable style={getStyles(['primaryBtn', { opacity: !participantCount ? 0.7 : 1 }])} onPress={() => handleNextPress(selectedEvent.event)} id="primaryBtn">
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
                        {t('way_activity.create_booking.button')}
                    </Text>
                </CustomPressable>
            </View>
        </View>
    )
}

export default ActivitiesCreateBooking